import { useContext, useEffect } from 'react'
import { UserContext } from 'context'
import { Div, ToggleOption, SelectedToggle } from './style'

interface IToggleProps {
  options: any
  toggle?: any
  setToggle?: any
}

export default function Toggle(props: IToggleProps) {
  // const { toggleOption, setToggleOption } = useContext(UserContext)
  const { options, toggle, setToggle } = props

  useEffect(() => {
    // if (setToggle) {
    //   return setToggle(Array.isArray(options[0]) ? options[0][1] : options[0])
    // }
    // setToggleOption(Array.isArray(options[0]) ? options[0][1] : options[0])
    if (toggle) return setToggle(toggle)
    setToggle(Array.isArray(options[0]) ? options[0][1] : options[0])
  }, [])

  const handleToggle = (value: any) => {
    // setToggle ? setToggle(value) : setToggleOption(value)
    // setToggleOption(value)
    setToggle(value)
  }

  const getClasse = (value: any) => {
    // if (toggle) {
    //   console.log(toggle)
    //   return toggle === value ? 'selected-toggle' : 'toggle-option'
    // }
    // return toggleOption === value ? 'selected-toggle' : 'toggle-option'
    return toggle === value ? 'selected-toggle' : 'toggle-option'
  }

  return (
    <Div>
      {options?.map((option: any, i: number) => {
        const value = Array.isArray(option) ? option[1] : option
        const label = Array.isArray(option) ? option[0] : option
        const disabled = Array.isArray(option) ? option[2] : false

        return getClasse(value) === 'selected-toggle' ? (
          <SelectedToggle
            key={`toggle_${label}_${i}`}
            disabled={disabled}
            data-testid={`toggle_${label}_${i}`}
            onClick={() => !disabled && handleToggle(value)}
          >
            {label}
          </SelectedToggle>
        ) : (
          <ToggleOption
            key={`toggle_${label}_${i}`}
            disabled={disabled}
            onClick={() => !disabled && handleToggle(value)}
            data-testid={`toggle_${label}_${i}`}
          >
            {label}
          </ToggleOption>
        )
      })}
    </Div>
  )
}
